'use strict';

var React = require('react');
var _ = require('underscore');
var util = require('../../helper/util');
var styleHelper = require('../../helper/styleHelper');

/**
 * 字母导航，需要根据字母进行canvas绘制
 */
var LetterNavigation = React.createClass({
  render: function () {
    var charArray = util.Text.delimitToWords('A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z');
    var h = styleHelper.getHeight(this.props);
    var s = 1;
    var labelStyle = {
      height: h / 26,
      fontSize: Math.round(h / 26 * 0.75),
      color: styleHelper.getBackgroundColor(this.props)
    };

    if(labelStyle.fontSize < 12){
      s = labelStyle.fontSize/12;
      labelStyle.transform = 'scale('+s+','+s+')';
      labelStyle.transformOrigin = 'center';
      labelStyle.height/=s;
    }
    var currentStyle;
    return (<div>
      {
        charArray.map(function (text, index) {
          currentStyle = _.extend({}, labelStyle, {
            top: h / 26 * index
          });
          return (
            <label key={index} style={currentStyle}>
              {text}
            </label>
          );
        }, this)
      }
    </div>);
  }
});

module.exports = LetterNavigation;



// WEBPACK FOOTER //
// ./src/views/Components/LetterNavigation.jsx